export const locale = {
    lang: 'zh1',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO': '設定',
          'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
        },
        'BOTONES':{
          'BOT1':{
            'TITULO': '上載員工資料庫',
            'BOTON': '設定'
          },
          'BOT2':{
            'TITULO': '上傳公司徽標',
            'BOTON': '設定'
          },
          'BOT3':{
            'TITULO': '技術要求資料',
            'BOTON': '查看更多'
          }
        },
        'BD':{
          'TITUHEAD': '上載員工資料庫',
          'INFO': '將您公司的員工資料庫上傳到系統中',
          'BOTONES':{
            'DescTemp': '下載範本'
          },
          'MENSAJES':{
            'CARGABD': '上載BD',
            'STATUS': '狀態',
            'CORRECTO': '資料庫上傳成功',
            'ERROR': '上傳發生錯誤'
          }
        },
        'LOGO':{
          'TITUHEAD': '上傳公司徽標',
          'INFO': '上載公司徽標圖像',
          'MENSAJES':{
            'CARGA': '上傳徽標圖片',
            'STATUS': '狀態',
            'CORRECTO': '徽標已成功上傳',
            'ERROR': '上傳發生錯誤'
          }
        },
        'REQTEC':{
          'TITUHEAD': '技術要求資料',
          'INFO': '平台以最佳功能運行的技術要求',
          'MENSAJES':{
            'CARGA': '',
            'STATUS': '狀態',
            'CORRECTO': '已成功加載',
            'ERROR': '加載錯誤'
          }
        }
      }
    }
};
